/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Traditional_ChineseInputs */



/**
* | output |
* | --- |
* | "Traditional Chinese" |
*
* @param {Traditional_ChineseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const traditional_chinese = /** @type {((inputs?: Traditional_ChineseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Traditional_ChineseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chinois traditionnel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Traditionelles Chinesisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cinese tradizionale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Традиционный китайский")
	if (locale === "es") return /** @type {LocalizedString} */ ("Chino tradicional")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("传统中文")
	if (locale === "ja") return /** @type {LocalizedString} */ ("繁体字中国語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परंपरागत चीनी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Chinês tradicional")
	return /** @type {LocalizedString} */ ("Traditional Chinese")
});